export default "__VITE_ASSET__9vZ$9ZYZ__"